import { Components, Theme } from '@mui/material';

const MuiAvatarGroup: Components<Theme>['MuiAvatarGroup'] = {
  styleOverrides: {
    avatar: {
      borderWidth: 1,
    },
  },
};

export default MuiAvatarGroup;
